import * as React from "react";
import { useContext } from "react";
import ReactDOM = require("react-dom");
import { Context } from "../appcontext";
import { VCXFontNoColor, VisualContext } from "../common/visualContext";
import { VCXContext } from "./app";
import { K2Img } from "./K2Image";
import { Renderer } from "./k2StyleRenderer";
import { K2TruncateText } from "./K2TruncateText";

interface ClientDialogProps {
  action: () => void;
  caption: string;
}

export const K2ClientDialog = (props: ClientDialogProps) => {
  const handleClick = () => {
    if (props.action) {
      props.action();
    }
  };

  let vcx = Context.getApplication()?.appViewRealizer?.VCX?.createVCXForZoomFactor(160);
  if (!vcx) vcx = VisualContext.Default.createVCXForZoomFactor(160);

  return (
    <>
      <div className="k2_client_dialog_overlay" />
      <div className="k2_client_dialog">
        <div>
          <K2TruncateText line={3} className={Renderer().renderFontRule(vcx.LabelControl.Font, vcx)}>
            {props.caption}
          </K2TruncateText>
        </div>
        <button className="loginBtn" onClick={handleClick}>
          <K2Img glyphId="wui*ok" height={24} vcx={Context.getApplication()?.appViewRealizer?.VCX} />
        </button>
      </div>
    </>
  );
};

export function showClientDialog(caption: string, action: () => void) {
  let el = document.createElement("div");
  document.body.appendChild(el);
  ReactDOM.render(
    <VCXContext.Provider value={{ renderer: Renderer(), vcx: Context.getApplication()?.appViewRealizer?.VCX }}>
      <K2ClientDialog
        action={() => {
          if (action) action();
          el.remove();
          el = undefined;
        }}
        caption={caption}
      />
    </VCXContext.Provider>,
    el
  );
}
